import { useQuery } from '@tanstack/react-query';
import { getSearchSuggestions } from '../borrowed/catalog-app/typescript/src/app/transport/api';

/**
 * Given the facet info, initial query, and list of indices, get the suggested type ahead values from the catalog.
 */
export const useCatalogSuggestions = params => {
  return useQuery(['suggestions', {
    facetInfo: params.facetInfo?.name,
    initialQuery: params.initialQuery,
    indices: params.indices
  }], () => getSearchSuggestions({
    facetInfo: params.facetInfo,
    initialValue: params.initialQuery,
    indices: params.indices,
    limit: params.limit
  }), {
    refetchOnWindowFocus: false,
    cacheTime: 60000
  });
};
//# sourceMappingURL=useCatalogSuggestions.js.map